import React, { FunctionComponent } from 'react';
import { ReviewList } from 'modules/review/components/ReviewList';

type ProReviewsRouteProps = {
  proPresentationId: number;
  proViewId: number;
};

const ProReviewsRoute: FunctionComponent<ProReviewsRouteProps> = ({
  proPresentationId,
  proViewId,
}) => <ReviewList presentationId={proPresentationId} proViewId={proViewId} />;

export default ProReviewsRoute;
